namespace Serenity {

    export interface BasicProgressDialogOptions {
        noProgress?: boolean;
        noCancelButton?: boolean;
    }

    export interface OperationProgressOptions extends BasicProgressDialogOptions {
        operationGuid?: string;
        service?: string;
    }

    export interface OperationProgressState {
        progressDialog: BasicProgressDialog;
        operationGuid: string;
        cleanup: () => void;
    }

    export class BasicProgressDialog extends Serenity.TemplatedDialog<BasicProgressDialogOptions> {

        constructor(opt?: BasicProgressDialogOptions) {
            super(opt);

            if (opt.noProgress) {
                this.byId('ProgressBar').hide();
                this.byId('ProgressLabel').hide();
            }
            else {
                this.byId('ProgressBar').progressbar({
                    max: 100,
                    value: 0,
                    change: (e, v) => {
                        this.byId('ProgressLabel').text(this.value + ' / ' + this.max);
                    }
                });
            }
        }

        public cancelled: boolean;

        public get max(): number {
            return this.byId('ProgressBar').progressbar().progressbar('option', 'max');
        }

        public set max(value: number) {
            this.byId('ProgressBar').progressbar().progressbar('option', 'max', value);
        }

        public get value(): number {
            return this.byId('ProgressBar').progressbar('value');
        }

        public set value(value: number) {
            this.byId('ProgressBar').progressbar().progressbar('value', value);
        }

        public get statusText(): string {
            return this.byId('StatusText').text();
        }

        public set statusText(value) {
            this.byId('StatusText').text(value);
        }

        public get title(): string {
            return this.element.dialog().dialog('option', 'title');
        }

        public set title(value: string) {
            this.element.dialog().dialog('option', 'title', value);
        }

        public cancelTitle: string;

        getDialogOptions() {
            var opt = super.getDialogOptions();
            opt.title = Q.text('Site.BasicProgressDialog.PleaseWait');
            opt.width = 600;
            if (!this.options.noCancelButton) {
                opt.buttons = [{
                    text: Q.text('Dialogs.CancelButton'),
                    click: () => {
                        this.cancelled = true;
                        this.element.closest('.ui-dialog')
                            .find('.ui-dialog-buttonpane .ui-button')
                            .attr('disabled', 'disabled')
                            .css('opacity', '0.5');

                        this.element.dialog('option', 'title', Q.trimToNull(this.cancelTitle) ||
                            Q.text('Site.BasicProgressDialog.CancelTitle'));
                    }
                }];
            }
            else
                opt.buttons = [];

            return opt;
        }

        initDialog() {
            super.initDialog();
            this.element.closest('.ui-dialog').find('.ui-dialog-titlebar-close').hide();
        }

        getTemplate() {
            return (
                "<div class='s-DialogContent s-BasicProgressDialogContent'>" +
                    "<div id='~_StatusText' class='status-text' ></div>" +
                    "<div id='~_ProgressBar' class='progress-bar'>" +
                        "<div id='~_ProgressLabel' class='progress-label' ></div>" +
                    "</div>" +
                "</div>");
        }

        public static startOperationProgress(options: Serenity.OperationProgressOptions): OperationProgressState {

            var state: OperationProgressState = {
                progressDialog: new Serenity.BasicProgressDialog(options),
                operationGuid: options.operationGuid || Serenity.generateGuid(),
                cleanup: () => {
                    state.progressDialog && state.progressDialog.dialogClose();
                    state.progressDialog = null;
                }
            };

            function updateStatus() {
                if (!state.operationGuid)
                    return;

                if (state.progressDialog && state.progressDialog.cancelled) {
                    Q.serviceCall({
                        service: options.service + 'Cancel',
                        request: {
                            OperationGuid: state.operationGuid
                        },
                        onSuccess: response => {
                            state.progressDialog && state.progressDialog.dialogClose();
                            state.progressDialog = null;
                            return;
                        }
                    });

                    state.operationGuid = null;
                    return;
                }

                Q.serviceCall({
                    service: options.service + 'Status',
                    request: {
                        OperationGuid: state.operationGuid
                    },
                    onSuccess: (r: any) => {
                        if (!state.progressDialog)
                            return;
                        state.progressDialog.statusText = r.StatusText;
                        if (r.Progress != null)
                            state.progressDialog.value = r.Progress;
                        window.setTimeout(() => updateStatus(), 500);
                    }
                });
            }

            state.progressDialog.dialogOpen();
            window.setTimeout(() => updateStatus(), 500);

            return state;
        }
    }

    export function generateGuid() {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
    }
}